module.exports = __webpack_public_path__ + "logo.png?4b0862849189597f860f80af75d3dcef";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.png
// module id = 82
// module chunks = 2